import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth
  },
  state: {
    idleVue: {
      isIdle: false
    }
  },
  mutations: {
    logout() {
      sessionStorage.removeItem('token');
    }
  },
  actions: {
    logout({ commit }) {
      commit('logout');
    }
  }
});
